import clsx from "clsx";
import { useEffect, useState } from "react";

import { TeamItem } from "../../types";
import { isValidImage, getTeamInitials } from "../../utils";

export type SectionTeamProps = {
  teamName: TeamItem["name"];
  teamPicture: TeamItem["picture"];
  displayTeamName?: boolean;
  displayTeamPicture?: boolean;
  brandedHeaderTextColor?: string;
};

export const TeamLabel = ({
  teamName,
  teamPicture,
  displayTeamName = true,
  displayTeamPicture = true,
  brandedHeaderTextColor,
}: SectionTeamProps) => {
  const [isImageValid, setIsImageValid] = useState(!!teamPicture);

  useEffect(() => {
    if (displayTeamPicture && teamPicture) {
      isValidImage(teamPicture)
        .then(setIsImageValid)
        .catch(() => setIsImageValid(false));
    } else if (!teamPicture) {
      setIsImageValid(false);
    }
  }, [teamPicture, displayTeamPicture]);

  if (!displayTeamPicture && !displayTeamName) {
    return null;
  }

  const headerTextColorClassNames: Record<string, string> = {
    default: "text-neutral-850",
    brandColor: "text-[var(--brand-color)]",
    black: "text-black",
    white: "text-white",
  };

  return (
    <header className="flex flex-row flex-1 flex-nowrap items-center rounded-small p-4 h-[7rem] font-poppins">
      {displayTeamPicture &&
        (isImageValid ? (
          <img
            aria-label={`${teamName} Logo`}
            className="h-[5rem] print:h-[7.5rem]"
            src={teamPicture!}
          />
        ) : (
          <div
            className="flex h-[4rem] w-[4rem] items-center justify-center text-paragraph font-semibold rounded select-none bg-[radial-gradient(circle,_rgba(223,227,236,1)_100%,_rgba(191,199,217,1)_100%)] overflow-hidden"
            data-testid="team-initials"
          >
            {getTeamInitials(teamName)}
          </div>
        ))}
      {displayTeamName && (
        <div
          data-testid="team-name"
          className={clsx(
            "flex-1 text-paragraph font-semibold my-0 mx-4 whitespace-nowrap overflow-hidden overflow-ellipsis",
            headerTextColorClassNames[brandedHeaderTextColor || "default"],
          )}
        >
          {teamName}
        </div>
      )}
    </header>
  );
};
